import React, { lazy } from 'react';
import { CRoutes, FlaggedRouteType } from 'src/routes';

const commonParam = ':permanenturl';

/** import pages */
const OrganizerPhysicalRaffleTicketsPage = lazy(() => import('src/pages/Account/Organizer/CommonPhysicalTickets'));
const AccountOrganizerExternalContributionsPage = lazy(
  () => import('src/pages/Account/Organizer/ExternalContributions')
);
const AccountOrganizerContributionsList = lazy(() => import('src/pages/Account/Organizer/Contributions'));
const AccountOrganizerMembersPage = lazy(() => import('src/pages/Account/Organizer/Members'));
const AccountOrganizerDonorPromoCodesPage = lazy(() => import('src/pages/Account/Organizer/DonorPromoCodes'));
const AccountOrganizerDonorEventBalancesPage = lazy(() => import('src/pages/Account/Organizer/DonorEventBalances'));
const AccountOrganizerEventRegistrationsPage = lazy(() => import('src/pages/Account/Organizer/EventRegistrations'));
const AccountOrganizerManualContributionsPage = lazy(() => import('src/pages/Account/Organizer/ManualContributions'));
const AccountOrganizerTeamsPage = lazy(() => import('src/pages/Account/Organizer/Teams'));
const AccountOrganizerEventGroupRegistrationsPage = lazy(
  () => import('src/pages/Account/Organizer/EventGroupRegistrations')
);
const AccountOrganizerRequestFundsPage = lazy(() => import('src/pages/Account/Organizer/RequestFunds'));

const AccountOrganizerAdministratorsPage = lazy(() => import('src/pages/Account/Organizer/Administrators'));
const AccountOrganizerRaffleWinnersPage = lazy(() => import('src/pages/Account/Organizer/RaffleWinners'));
const AccountOrganizerSweepstakesWinnersPage = lazy(() => import('src/pages/Account/Organizer/SweepstakesWinners'));
const AccountOrganizerWidgetWizardPage = lazy(() => import('src/pages/Account/Organizer/WidgetWizard'));
const AccountOrganizerCrowdfundingRewardsPage = lazy(() => import('src/pages/Account/Organizer/CrowdfundingRewards'));
const AccountOrganizerPaddleRaisePage = lazy(() => import('src/pages/Account/Organizer/PaddleRaise'));
/** define routes */
const getPath = (path: string) => `/account/organizer/${path}/${commonParam}`;

export const ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_RAFFLE_TICKETS = getPath('physicalRaffleTickets');
export const ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_SWEEPSTAKES_TICKETS = getPath('physicalSweepstakesTickets');
export const ROUTE_ACCOUNT_ORGANIZER_EXTERNAL_CONTRIBUTIONS = getPath('externalcontributions');
export const ROUTE_ACCOUNT_ORGANIZER_DONOR_PROMOCODES = getPath('DonorPromoCodes/Index');
export const ROUTE_ACCOUNT_ORGANIZER_DONOR_EVENT_BALANCES = getPath('donorEventBalances');
export const ROUTE_ACCOUNT_ORGANIZER_MANUAL_CONTRIBUTIONS = getPath('manualContributions');
export const ROUTE_ACCOUNT_ORGANIZER_MEMBERS = getPath('Members');
export const ROUTE_ACCOUNT_ORGANIZER_EVENT_GROUP_REGISTRATIONS = getPath('EventGroupRegistrations');
export const ROUTE_ACCOUNT_ORGANIZER_EVENT_REGISTRATIONS = getPath('eventRegistrations');
export const ROUTE_ACCOUNT_ORGANIZER_TEAMS = getPath('teams');
export const ROUTE_ACCOUNT_ORGANIZER_ADMINISTRATORS = getPath('Administrators');
export const ROUTE_ACCOUNT_ORGANIZER_RAFFLE_WINNERS = getPath('RaffleWinners');
export const ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_WINNERS = getPath('SweepstakesWinners');
export const ROUTE_ACCOUNT_ORGANIZER_REQUEST_FUNDS = getPath('requestFunds');

// todo
export const ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_OFFLINE_ENTRIES = getPath('sweepstakeOfflineEntries');
// todo
export const ROUTE_ACCOUNT_ORGANIZER_WIDGET_WIZARD = getPath('WidgetWizard');
export const ROUTE_ACCOUNT_ORGANIZER_CONTRIBUTIONS = getPath('contributions');
export const ROUTE_ACCOUNT_ORGANIZER_CROWDFUNDING_REWARDS = getPath('CrowdfundingRewards');
export const ROUTE_ACCOUNT_ORGANIZER_PADDLE_RAISE = getPath('PaddleRaise');

/** generate links */
const getLink = (route: string) => (url: string) => route.replace(`${commonParam}`, url);

export const getLinkRouteAccountOrganizerPhysicalRaffleTickets = getLink(
  ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_RAFFLE_TICKETS
);
export const getLinkRouteAccountOrganizerSweepStakeTickets = getLink(
  ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_SWEEPSTAKES_TICKETS
);
export const getLinkRouteAccountOrganizerSweepstakesOfflineEntries = getLink(
  ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_OFFLINE_ENTRIES
);
export const getLinkRouteAccountOrganizerSweepstakesWinners = getLink(ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_WINNERS);
export const getLinkRouteAccountOrganizerRaffleWinners = getLink(ROUTE_ACCOUNT_ORGANIZER_RAFFLE_WINNERS);
export const getLinkRouteAccountOrganizerContributions = getLink(ROUTE_ACCOUNT_ORGANIZER_CONTRIBUTIONS);
export const getLinkRouteAccountOrganizerEventGroupRegistrations = getLink(
  ROUTE_ACCOUNT_ORGANIZER_EVENT_GROUP_REGISTRATIONS
);
export const getLinkRouteAccountOrganizerExternalContributions = getLink(
  ROUTE_ACCOUNT_ORGANIZER_EXTERNAL_CONTRIBUTIONS
);
export const getLinkRouteAccountOrganizerDonorPromoCodes = getLink(ROUTE_ACCOUNT_ORGANIZER_DONOR_PROMOCODES);
export const getLinkRouteAccountOrganizerManualContributions = getLink(ROUTE_ACCOUNT_ORGANIZER_MANUAL_CONTRIBUTIONS);
export const getLinkRouteAccountOrganizerMembers = getLink(ROUTE_ACCOUNT_ORGANIZER_MEMBERS);
export const getLinkRouteAccountOrganizerTeams = getLink(ROUTE_ACCOUNT_ORGANIZER_TEAMS);
export const getLinkRouteAccountOrganizerEventRegistrations = getLink(ROUTE_ACCOUNT_ORGANIZER_EVENT_REGISTRATIONS);
export const getLinkRouteAccountOrganizerAdministrators = getLink(ROUTE_ACCOUNT_ORGANIZER_ADMINISTRATORS);

/** export flagged routes */
export const accountOrganizerFlaggedRoutes: Record<string, FlaggedRouteType> = {
  ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_WINNERS: {
    path: ROUTE_ACCOUNT_ORGANIZER_SWEEPSTAKES_WINNERS,
    flag: 'ReactAccountOrganizerSweepstakesWinnersPage',
    component: AccountOrganizerSweepstakesWinnersPage,
    title: '-',
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  ROUTE_ACCOUNT_ORGANIZER_CROWDFUNDING_REWARDS: {
    path: ROUTE_ACCOUNT_ORGANIZER_CROWDFUNDING_REWARDS,
    flag: 'ReactAccountOrganizerCrowdfundingRewardsPage',
    component: AccountOrganizerCrowdfundingRewardsPage,
    title: 'View Crowdfunding',
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
};

/** export routes */
export const accountOrganizerRoutes: CRoutes = [
  {
    path: ROUTE_ACCOUNT_ORGANIZER_CONTRIBUTIONS,
    Component: AccountOrganizerContributionsList,
    exact: true,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_RAFFLE_TICKETS,
    Component: () => <OrganizerPhysicalRaffleTicketsPage isRaffle />,
    exact: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_PHYSICAL_SWEEPSTAKES_TICKETS,
    Component: OrganizerPhysicalRaffleTicketsPage,
    exact: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_EVENT_GROUP_REGISTRATIONS,
    Component: AccountOrganizerEventGroupRegistrationsPage,
    exact: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_EXTERNAL_CONTRIBUTIONS,
    Component: AccountOrganizerExternalContributionsPage,
    exact: true,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_DONOR_PROMOCODES,
    Component: AccountOrganizerDonorPromoCodesPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_DONOR_EVENT_BALANCES,
    Component: AccountOrganizerDonorEventBalancesPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_MANUAL_CONTRIBUTIONS,
    Component: AccountOrganizerManualContributionsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_MEMBERS,
    Component: AccountOrganizerMembersPage,
    liveStreamBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_TEAMS,
    Component: AccountOrganizerTeamsPage,
    liveStreamBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_EVENT_REGISTRATIONS,
    Component: AccountOrganizerEventRegistrationsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_ADMINISTRATORS,
    Component: AccountOrganizerAdministratorsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: false,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_RAFFLE_WINNERS,
    Component: AccountOrganizerRaffleWinnersPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_REQUEST_FUNDS,
    Component: AccountOrganizerRequestFundsPage,
    liveStreamBannerAvailable: true,
    testModeBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_WIDGET_WIZARD,
    Component: AccountOrganizerWidgetWizardPage,
    liveStreamBannerAvailable: true,
  },
  {
    path: ROUTE_ACCOUNT_ORGANIZER_PADDLE_RAISE,
    Component: AccountOrganizerPaddleRaisePage,
    liveStreamBannerAvailable: false,
    showFooter: false,
  },
];
